<template>
  <div
    v-if="activeContract"
    class="report-container page-padding"
    style="font-family: Arial, sans-serif; color: black"
  >
    <section
      style="margin-bottom: 30px; display: flex; justify-content: center"
    >
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          border-radius: 15px;
          padding: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1000px;
        "
      >
        <h3 style="font-weight: 500; text-align: center">
          {{ activeContract.code + " (" + activeContract.plan.name + ")" }}
        </h3>
        <div style="width: 850px">
          <h4 style="font-weight: 500; text-decoration: underline">
            Personal Details
          </h4>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">First Name:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.first_name }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Last Name:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.last_name }}</label>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Date of Birth:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.date_of_birth }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Nationality:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{
                this.countries.find(
                  (country) => country.id === authUser.userable.nationality_id
                ).name
              }}</label>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">ID# / Passport #:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.pasport_id }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Other Nationality:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>-</label>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Gender:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{
                this.genderList.find(
                  (gender) => gender.id === authUser.userable.gender
                ).name
              }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Client ID:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.code }}</label>
            </div>
          </div>
        </div>

        <div style="width: 850px; margin-top: 20px">
          <h4 style="font-weight: 500; text-decoration: underline">
            Contact Information
          </h4>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 850px;
            "
          >
            <div style="width: 19%; text-align: left">
              <label style="font-weight: bold">Home Address:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 81%;
              "
            >
              <label>{{ authUser.userable.home_address }}</label>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Phone Number:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.mobile_number }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Email Address:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.email }}</label>
            </div>
          </div>
        </div>

        <div style="width: 850px; margin-top: 20px">
          <h4 style="font-weight: 500; text-decoration: underline">
            Emergency Conttact
          </h4>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Name:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.emergency_contact_name }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Phone Number:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.emergency_contact_number }}</label>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Relationship:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.emergency_contact_relation }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Email Address:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ authUser.userable.emergency_contact_email }}</label>
            </div>
          </div>
        </div>

        <div style="width: 850px; margin-top: 20px">
          <h4 style="font-weight: 500; text-decoration: underline">
            Subscription Details (For Management Use):
          </h4>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Plan Type:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ activeContract.plan.name }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Contract Length:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ getContractDuration(activeContract) }}</label>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Estimated ROI:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ activeContract.plan.est_roi }}%</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Invested Principle:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label
                >{{ activeContract.invested_principal }}
                {{ activeContract.currency.code }}</label
              >
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Start Date:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ activeContract.start_date }}</label>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">End Date:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label>{{ activeContract.maturity_date }}</label>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-bottom: 10px; width: 850px">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              height: 25px;
              width: 400px;
              margin-right: 50px;
            "
          >
            <div style="width: 40%; text-align: left">
              <label style="font-weight: bold">Withdrawal Notice:</label>
            </div>
            <div
              style="
                border-bottom: 1px solid black;
                text-align: center;
                width: 60%;
              "
            >
              <label
                >{{ activeContract.plan.withdrawal_notice }}
                {{ activeContract.plan.withdrawal_notice_period }}</label
              >
            </div>
          </div>
        </div>
        <div
          class="action-buttons"
          style="text-align: center; margin-top: 30px"
          v-if="!activeContract.confirmed"
        >
          <button
            @click="confirmContract"
            style="
              background-color: #8cc63f;
              color: white;
              padding: 10px 20px;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              width: 135px;
            "
          >
            Confirm
          </button>
        </div>
        <div
          class="action-buttons"
          style="text-align: center; margin-top: 30px"
          v-else-if="activeContract.confirmed"
        >
          <h4
            style="
              font-weight: bold;
              font-style: italic;
              text-decoration: underline;
            "
          >
            Confirmed
            {{
              activeContract.confirmation_date
                ? "at " + activeContract.confirmation_date
                : null
            }}
          </h4>
          <h4
            style="
              font-weight: bold;
              font-style: italic;
              text-decoration: underline;
            "
          >
            {{
              authUser.userable.first_name + " " + authUser.userable.last_name
            }}
          </h4>
        </div>
      </md-card>
    </section>

    <!-- Action Buttons -->
    <section></section>
  </div>
</template>
<script>
import ManagePlanModal from "./components/modals/managePlanModal.vue";
import { BarChart } from "../../components/ChartJS";
import { mapState } from "vuex";
import InvestorContractsFilter from "../../filters/InvestorContractsFilter";
import sweetAlert from "sweetalert2";
import { EventBus } from "../../event-bus";
import moment from "moment";

export default {
  components: {
    BarChart,
    ManagePlanModal,
  },
  data() {
    return {
      contractCode: null,
      genderList: [
        { id: 0, name: "Male" },
        { id: 1, name: "Female" },
        { id: null, name: "Other" },
      ],
    };
  },
  created: function () {
    this.contractCode = this.$route.params.contractCode;
    let self = this;
    EventBus.$on("changeTab", function (tab) {
      if (tab == "dashboard") {
        self.$router.push("/" + self.authUser.userable_type + "/dashboard");
      }
    });
    this.scrollToTop();
    var contractsFilter = InvestorContractsFilter();
    contractsFilter.codes = [this.contractCode];
    contractsFilter.with = ["plan", "currency"];
    this.$store.dispatch("searchInvestorContracts", {
      filter: contractsFilter,
      resultMode: "default",
    });
    this.$store.dispatch("searchCountries");
  },
  computed: {
    ...mapState({
      activeContract: (state) =>
        state.contractStore.investorContractSearch.investorContracts[0],
      countries: (state) => state.countryStore.countrySearch.countries,
      authUser: (state) => state.userStore.authUser,
      updateInvestorContractStatus: (state) =>
        state.contractStore.investorContractUpdate.updateInvestorContractStatus,
    }),
  },
  methods: {
    scrollToTop() {
      const modalContent = document.querySelector(".md-theme-default");
      modalContent.scrollTo(0, 0);
    },

    getContractDuration(contract) {
      var start = contract.start_date;
      var end = contract.maturity_date;
      let duration = moment.duration(moment(start).diff(moment(end)));
      let durationString = "";
      if (duration.years() / -1) {
        durationString += duration.years() / -1 + " Years, ";
      }
      if (duration.months() / -1) {
        durationString += duration.months() / -1 + " Months, ";
      }
      if (duration.days() / -1) {
        durationString += duration.days() / -1 + " Days, ";
      }
      durationString = durationString.substring(0, durationString.length - 2);
      return durationString;
    },

    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },

    confirmContract() {
      sweetAlert({
        title: "Are you sure?",
        text:
          "Please sign with your full name to confirm this contract (" +
          this.authUser.userable.first_name +
          " " +
          this.authUser.userable.last_name +
          ")",
        input: "text",
        inputPlaceholder: "Enter your full name here",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.dismiss == "cancel") {
          return;
        }
        /* Read more about isConfirmed, isDenied below */
        if (
          result.value ===
          this.authUser.userable.first_name +
            " " +
            this.authUser.userable.last_name
        ) {
          this.$store.dispatch("confirmInvestorContract", {
            id: this.activeContract.id,
            confirmed: true,
          });
        } else {
          sweetAlert({
            title: "Error",
            text: "Your signature does not match",
            type: "error",
            confirmButtonText: "Return",
            confirmButtonColor: "#d73535",
          });
        }
      });
    },
  },
  watch: {
    updateInvestorContractStatus() {
      if (this.updateInvestorContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been confirmed successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type);
        });
      } else if (this.updateInvestorContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract confirmation has failed",
          type: "error",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style scoped>
table th,
table td {
  text-align: left;
}
button:hover {
  opacity: 0.9;
}
.performance-cards {
  background-color: white;
  border-radius: 15px;
  padding: 25px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  max-width: 350px;
}
.page-padding {
  padding: 20px 50px;
}
.high-risk-lev {
  color: #ee4444;
}
.medium-risk-lev {
  color: #f19e2d;
}
.low-risk-lev {
  color: #bed663;
}
.label {
  margin-bottom: 0;
}
@media (max-width: 767px) {
  .page-padding {
    padding: 20px 25px;
  }
  .bar-charts-padding {
    padding: 0;
  }
  .performance-divs {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/investor/contract.vue